module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "alert alert-info"
  }, [(_vm.btnClose) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeMe()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.obj) ? _c('div', [_vm._l((_vm.label), function(lbl) {
    return (_vm.isHtml) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(lbl)
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.label), function(lbl) {
    return (!_vm.isHtml) ? _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-info-sign",
      attrs: {
        "aria-valuemin": "true"
      }
    }), _vm._v(" " + _vm._s(lbl))]) : _vm._e()
  })], 2) : _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-info-sign",
    attrs: {
      "aria-valuemin": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.label) + "\n        ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bcdd0d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Banet/errorsAndNotifications/BanetInfo.vue
// module id = 689
// module chunks = 0